export default "__VITE_ASSET__Dv4O_2Zq__"